import axios from "axios";
import {PURCHASE_ORDER_APPROVAL_LIST_URL, PURCHASE_ORDER_APPROVAL_CHECK_URL} from '../../config/stck.links'
import {toast} from 'react-toastify'

export const FETCH_STCK_PO_APPROVAL_LIST = 'FETCH_STCK_PO_APPROVAL_LIST'
export const RECEIVE_STCK_PO_APPROVAL_LIST = 'RECEIVE_STCK_PO_APPROVAL_LIST'
export const FAILED_STCK_PO_APPROVAL_LIST = 'FAILED_STCK_PO_APPROVAL_LIST'

export function fetchStckPoApproval(obj){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_STCK_PO_APPROVAL_LIST});
        axios({
            method: 'post',
            url: PURCHASE_ORDER_APPROVAL_LIST_URL,
            headers: {
                Authorization: auth
            },
            data:obj
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_STCK_PO_APPROVAL_LIST,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_STCK_PO_APPROVAL_LIST
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_STCK_PO_APPROVAL_LIST
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_STCK_PO_APPROVAL_LIST
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_STCK_PO_APPROVAL_LIST
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_STCK_PO_APPROVAL_LIST
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_STCK_PO_APPROVAL_LIST
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}

export const FETCH_STCK_PO_APPROVAL_CHECK = 'FETCH_STCK_PO_APPROVAL_CHECK'
export const RECEIVE_STCK_PO_APPROVAL_CHECK = 'RECEIVE_STCK_PO_APPROVAL_CHECK'
export const FAILED_STCK_PO_APPROVAL_CHECK = 'FAILED_STCK_PO_APPROVAL_CHECK'

export function fetchStckPoApprovalCheck(_id_po){    return (dispatch, getState) => {
        
            let {authStore} = getState();
            let auth = null;
            if(authStore.authData){
                auth = authStore.authData.result.token;
            }
        dispatch({type: FETCH_STCK_PO_APPROVAL_CHECK});
        axios({
            method: 'post',
            url: PURCHASE_ORDER_APPROVAL_CHECK_URL,
            headers: {
                Authorization: auth
            },
            data: {
                id_po: _id_po
            }
        })
        .then((response) => {
            dispatch( {
                type: RECEIVE_STCK_PO_APPROVAL_CHECK,
                payload: response.data
            })
        })
        .catch(function(error){
            if (error.response) {
                if(error.response.status === 401) {
                    dispatch({
                        type: FAILED_STCK_PO_APPROVAL_CHECK
                    })
                    return toast.error("Invalid username or password! Please try again!");
                } else if (error.response.status === 404 || error.response.status === 500) {
                    dispatch({
                        type: FAILED_STCK_PO_APPROVAL_CHECK
                    })
                    return toast.error("Server cannot be contacted! Please ask your system administrator!");
                } else if (error.response.status === 400) {
                    dispatch({
                        type: FAILED_STCK_PO_APPROVAL_CHECK
                    })
                    return toast.error(error.response.data.message);
                } else {
                    dispatch({
                        type: FAILED_STCK_PO_APPROVAL_CHECK
                    })
                    return toast.error('Something went wrong... Please try again later...');
                }
            } else if (error.request) {
                dispatch({
                    type: FAILED_STCK_PO_APPROVAL_CHECK
                })
                return toast.error('Request error! Please try again later...')
            } else {
                dispatch({
                    type: FAILED_STCK_PO_APPROVAL_CHECK
                })
                return toast.error('Something went wrong... Please try again later...')
            }
        })
    }
}